import React, { ReactElement } from 'react';

import { Box } from 'components';

interface SpaceProps {
  height: { m?: number; t?: number; d?: number } | number;
}

const Space = ({ height }: SpaceProps): ReactElement => <Box height={height} />;

export default Space;
